module.exports = __webpack_public_path__ + "img/shop4_1.d25602ae.png";